import { render } from "./CrmKanbanTopHeaderSearchModalIpad.vue?vue&type=template&id=3e477f48"
import script from "./CrmKanbanTopHeaderSearchModalIpad.vue?vue&type=script&lang=js"
export * from "./CrmKanbanTopHeaderSearchModalIpad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__